import { useCallback } from 'react';

import { ICause } from '@givebacks/api/core';
import { useNavigate } from 'react-router-dom';

const ONBOARDING_ROUTES = {
  account: () => '/account',
  // Cause-related routes
  cause: (causeId: string) => `/causes/${causeId}`,
  causes: () => '/causes',

  // Student fees routes
  studentFees: () => '/student-fees/students',

  // Rewards routes
  rewards: () => '/rewards',

  // Wallet routes
  wallet: () => '/wallet',
  walletPurchases: () => '/wallet/purchases',
  rewardsActivity: () => '/account/rewards',
} as const;

export const useCauseActions = (cause?: ICause) => {
  const navigate = useNavigate();

  const handleGoToAccount = useCallback(() => {
    navigate(ONBOARDING_ROUTES.account());
  }, [navigate]);

  const handleGoToCause = useCallback(() => {
    if (cause) {
      navigate(ONBOARDING_ROUTES.cause(cause.uuid));
    }
  }, [navigate, cause]);

  const handleGoToFees = useCallback(() => {
    navigate(ONBOARDING_ROUTES.studentFees());
  }, [navigate]);

  const handleGoToRewards = useCallback(() => {
    navigate(ONBOARDING_ROUTES.rewards());
  }, [navigate]);

  const handleGoToWallet = useCallback(() => {
    navigate(ONBOARDING_ROUTES.wallet());
  }, [navigate]);

  const handleGoToPurchases = useCallback(() => {
    navigate(ONBOARDING_ROUTES.walletPurchases());
  }, [navigate]);

  const handleGoToRewardsActivity = useCallback(() => {
    navigate(ONBOARDING_ROUTES.rewardsActivity());
  }, [navigate]);

  return {
    handleGoToAccount,
    handleGoToCause,
    handleGoToFees,
    handleGoToRewards,
    handleGoToWallet,
    handleGoToPurchases,
    handleGoToRewardsActivity,
  };
};
